// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__fSiBc","badges":"styles_badges__KfKmJ"};